import { getExtensionListForSSR } from '@atlassian/forge-ui/provider';

import { preloadSpaceDetail } from '@confluence/space-utils/entry-points/preloadSpaceDetail';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { getUseExtensionListOptions } from './getUseExtensionListOptions';

export const preloadExtensions = async ({
	spaceKey,
	cloudId,
	activationId,
	locale,
	hasAccessNarrowingSupport,
	expandAppOwner,
	moduleType,
	queryOptions,
	skip,
	skipFilter,
}) => {
	const { data } = await preloadSpaceDetail(spaceKey);
	const dataClassificationTags = data?.space?.dataClassificationTags;

	return getExtensionListForSSR({
		...getUseExtensionListOptions({
			cloudId,
			activationId,
			locale,
			dataClassificationTags,
			hasAccessNarrowingSupport,
			expandAppOwner,
			moduleType,
			queryOptions,
			skip,
			skipFilter,
		}),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		queryFn: query,
	});
};
